export default "__VITE_ASSET__ymsljOo9__"